import Swal from "sweetalert2";
import { authHeader } from './authHeader';

var url_json = require("../location.json");

if (
  window.location.origin === "http://localhost:3000" ||
  window.location.origin === "http://localhost:3001"
) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Cursos = {
  agregarCurso: async (data) => {
    let url = url_json + "/curso";
    let body = {
      archivado: data.archivado,
      area: data.area,
      carrusel_imagenes: data.carrusel_imagenes,
      contenido: data.contenido,
      data_pago: data.data_pago,
      descripcion_curso: data.descripcion_curso,
      descripcion_externa: data.descripcion_externa,
      descripcion_interna: data.descripcion_interna,
      dias: data.dias,
      etiquetas: data.etiquetas,
      fecha_fin: data.fecha_fin,
      fecha_inicio: data.fecha_inicio,
      fecha_relampago: data.fecha_relampago,
      fechas: data.fechas,
      formato_pago: data.formato_pago,
      formato: data.formato,
      gratis: data.gratis,
      hora_fin: data.hora_fin,
      hora_inicio: data.hora_inicio,
      imagen_externa: data.imagen_externa,
      url_youtube: data.url_youtube,
      imagen_indvidual: data.imagen_indvidual,
      imagen_interna: data.imagen_interna,
      modalidad: data.modalidad,
      nivel: data.nivel,
      nombre: data.nombre,
      oferta_relampago: data.oferta_relampago,
      requisitos: data.requisitos,
      storage: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Curso agregado correctamente",
        "success"
      );
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el curso, codigo: " + res.message,
        "error"
      );
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtenerCursos: async () => {
    let url = url_json + "/curso";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerCursosDatosOferta: async () => {
    let url = url_json + "/curso";
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnCurso: async (id) => {
    let url = url_json + "/curso/" + id;
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarCurso: async (data, id) => {
    try {
      let url = url_json + "/curso/" + id;
      let body = {
        archivado: data.archivado,
        area: data.area,
        cantidad_descuento_alumno: data.cantidad_descuento_alumno,
        carrusel_imagenes: data.carrusel_imagenes,
        contenido: data.contenido,
        data_pago: data.data_pago,
        descripcion_curso: data.descripcion_curso,
        descripcion_externa: data.descripcion_externa,
        descripcion_interna: data.descripcion_interna,
        descuento_alumno: data.descuento_alumno,
        dias: data.dias,
        etiquetas: data.etiquetas,
        fecha_fin: data.fecha_fin,
        fecha_inicio: data.fecha_inicio,
        fechas: data.fechas,
        formato_pago: data.formato_pago,
        formato: data.formato,
        gratis: data.gratis,
        hora_fin: data.hora_fin,
        hora_inicio: data.hora_inicio,
        imagen_externa: data.imagen_externa,
        url_youtube: data.url_youtube,
        imagen_indvidual: data.imagen_indvidual,
        imagen_interna: data.imagen_interna,
        modalidad: data.modalidad,
        nivel: data.nivel,
        nombre: data.nombre,
        oferta_relampago: data.oferta_relampago,
        requisitos: data.requisitos,
        slug: data.slug,
        storage: true,
      };

      if (data.estado_relampago) {
        body.estado_relampago = data.estado_relampago;
        body.fecha_relampago = data.fecha_relampago;
      }

      let request = {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: authHeader(),
      };

      let response = await fetch(url, request);
      let res = await response.json();
      if (response.ok) {
        Swal.fire(
          "Modificación exitosa!",
          "Curso modificado correctamente",
          "success"
        );
      } else {
        Swal.fire("Error!", "No se pudo modificar el curso", "error");
      }
      return { success: response.ok, data: res.data };
    } catch (error) {
      Swal.fire("Error!", "No se pudo modificar el curso", "error");
    }
  },
  eliminarCurso: async (id) => {
    let url = url_json + "/curso/delete/" + id;
    let request = {
      method: "PATCH",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Eliminación exitosa!",
        "Curso eliminado correctamente",
        "success"
      ).then(() => {
        window.location.replace("/cursos-diplomados");
      });
    } else {
      Swal.fire("Error!", "No se pudo eliminar el curso", "error");
    }
    return { success: response.ok, data: res.data };
  },
  obtenerUnCursoArea: async (area) => {
    let url = url_json + "/curso/area";
    let body = {
      area,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnCursoNombre: async (nombre) => {
    let url = url_json + "/curso/nombre/" + nombre;
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnCursoSlug: async (slug) => {
    let url = url_json + "/curso/slug/" + slug;
    let request = {
      method: "GET",
      headers: authHeader(),
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  actualizarCorsosOfertaMasivo: async (body) => {
    try {
      let url = url_json + "/curso/oferta-relampago-masivo";

      let request = {
        method: "PATCH",
        body: JSON.stringify(body),
        headers: authHeader(),
      };

      let response = await fetch(url, request);
      let res = await response.json();
      if (response.ok) {
        Swal.fire(
          "Modificación exitosa!",
          "Oferta relampago activada correctamente",
          "success"
        );
      } else {
        Swal.fire("Error!", "No se pudo modificar el curso", "error");
      }
      return { success: response.ok, data: res.data };
    } catch (error) {
      Swal.fire("Error!", "No se pudo modificar el curso", "error");
    }
  },
};

export default Cursos;
